import PropTypes from 'prop-types';

const quietTimeScheduleTimePeriodPropType = PropTypes.shape({
  id: PropTypes.number,
  quietTime: PropTypes.number,
  startTimePeriodTypeId: PropTypes.number,
  startHours: PropTypes.number,
  startMinutes: PropTypes.number,
  endTimePeriodTypeId: PropTypes.number,
  endHours: PropTypes.number,
  endMinutes: PropTypes.number,
});

export default { quietTimeScheduleTimePeriodPropType };
